module.exports = __webpack_public_path__ + "img/img_baby_light_emergency.d7aaddf3.png";